module.exports = __webpack_public_path__ + "img/divider-rip-old.7f468558.png";